// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentTukIndex } = lazily(() => import('pages/back-office/content-management/tuk'))

const contentTukRoutes: IRoute[] = [
  {
    path: CONTENT_URL.TUK,
    component: ContentTukIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: { label: 'contentManagementTuk.tuk.tuk', accessCodes: [556] },
    },
  },
]

export { contentTukRoutes }
